import angular from 'angular';

(function() {
    'use strict';

    // Component DEF
    var kissDraggableTable = {
        controller: 'DraggableTableCtrl as vm',
        templateUrl: require('./draggable-table.html'),
        bindings: {
            editable: '<',
            filterFn: '&',
            removeFn: '&',
            tableData: '=',
            typeSection: '@'
        }
    };

    // Add to the App
    angular.module('app.principal').component('kissDraggableTable', kissDraggableTable);
})();
